import { Button } from '@material-ui/core';
import { AccountCircle as AccountCircleIcon, Close as CloseIcon } from '@material-ui/icons';
import React, { memo } from 'react';

const iconClasses = 'flex w-10 h-10 justify-center items-center rounded-full shadow-md';

const GroupUserDetails = ({
  avatarUrl,
  firstName,
  lastName,
  isTheSameUser,
  shouldShowRemoveButton,
  handleRemoveFromTeam,
  splitPercentage,
  isUserInGroup
}) => {
  return (
    <div className="flex items-center my-2.5">
      {avatarUrl ? (
        <img className={iconClasses} src={avatarUrl} alt="User avatar" />
      ) : (
        <AccountCircleIcon className={`${iconClasses} text-slate-300`} />
      )}
      <div className="ml-4 flex-1 text-slate-700 font-medium">
        {`${firstName} ${lastName}${isTheSameUser ? ' (you)' : ''}`}
      </div>
      {isUserInGroup && (
        <div
          className={`font-bold text-slate-900 ${shouldShowRemoveButton ? '' : 'mr-16'}`}>
          {splitPercentage.toFixed(2)}%
        </div>
      )}

      {shouldShowRemoveButton && (
        <Button className="!text-slate-400 hover:!text-red-600" onClick={handleRemoveFromTeam}>
          <CloseIcon />
        </Button>
      )}
    </div>
  );
};

export default memo(GroupUserDetails);
